import { ReactElement } from 'react';

import { ControlledInputs } from '@/components';

import { useMeetingTemplateFormContext } from '../../hooks/use-meeting-template-form-context';

const MeetingName = (): ReactElement => {
  const form = useMeetingTemplateFormContext();
  return (
    <ControlledInputs.TextField
      ControllerProps={{
        control: form.control,
        name: 'meeting_name',
      }}
      fullWidth
      label="Meeting Name"
      placeholder="Enter meeting name"
    />
  );
};

export default MeetingName;
